import React, { Component } from "react";
import store from "store";
import $ from "jquery";
import Page from "../Page";
import { API_ENTITY_TYPE, API_PROGRAM, API_SEARCH, QueryParam } from "../Util";
import { Button, Col, Input, Modal, Preloader, Row } from "react-materialize";
import { notify } from "react-notify-toast";
import { Link } from "react-router-dom";
import Waypoint from "react-waypoint";
import { trans } from "../Lang";
import { filter } from "../../assets";
import "../../styles/course-catalog.css";
import Beforeunload from "react-beforeunload";
import CourseItem from "../common/CourseItem";

class CourseCatalog extends Page {
  static LIMIT = 20;

  constructor(props) {
    super(props);
    let params = QueryParam();

    if (!params["time"]) {
      params["time"] = 0;
    }

    this.state = {
      list: [],
      params,
      offset: 0,
      end: false,
      optionPrograms: [],
      optionEntityTypes: [],
      user: null,
    };

    this.activateFilter = this.activateFilter.bind(this);
    this.handleChangeFilter = this.handleChangeFilter.bind(this);
    //this._loadMoreContent = this._loadMoreContent.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    let { params } = this.state;
    let prev_params = prevState.params;
    const { search } = this.props.location;
    const prev_search = prevProps.location.search;
    let { price_min } = params;
    if (price_min !== prev_params["price_min"]) {
      this.handleLoadData(1);
    } else if (prev_search !== search) {
      params.category_id = QueryParam().category_id;
      params.entity_type_id = QueryParam().entity_type_id;
      params.access_type = QueryParam().access_type;
      this.handleLoadData(1, params);
    }
  }

  componentDidMount() {
    $(".modal-overlay").trigger("click");

    let price_range = store.get("price_range");
    let pac_range = store.get("pac_range");

    let user = store.get("userdata");

    this.handleLoadProgram();
    this.handleLoadEntityType();

    if (!price_range || !pac_range) {
      // this.handleLoadData(1);
      this.setState({ user });
      store.set("price_range", { price_min: 0, price_max: 200000 });
      store.set("pac_range", { pac_min: 0, pac_max: 100 });
    }
    if (this.state.params) {
      let { params } = this.state;
      let price_range = store.get("price_range");
      let pac_range = store.get("pac_range");
      let { price_min, price_max } = price_range
        ? price_range
        : { price_min: 0, price_max: 200000 };
      let { pac_min, pac_max } = pac_range
        ? pac_range
        : { pac_min: 0, pac_max: 0 };
      params["price_min"] = price_min;
      params["price_max"] = price_max;
      params["pac_min"] = pac_min;
      params["pac_max"] = pac_max;
      this.setState({ params, user });
      this.handleLoadData(1, params);
    }
    $(".btn-help").hide();
    $("#filter-button-div").click(function () {
      $("#filter-modal-button").trigger("click");
      // $("#modal-profile").modal("open");
    });
  }

  handleChangeFilter(filters) {
    let { params } = this.state;
    params = { ...params, ...filters };
    this.setState({ params });

    if (params.category_id) {
      filters["category_id"] = params.category_id;
    }
    if (params.access_type) {
      filters["access_type"] = params.access_type;
    }

    this.props.history.push({
      pathname: "/course/catalog",
      search:
        "?" +
        Object.keys(filters)
          .map((key) => key + "=" + filters[key])
          .join("&"),
    });

    // this.handleLoadData(1, params);
  }

  /*componentWillReceiveProps(props) {
		console.log('cwrp');
		let params = QueryParam();
		let price_range = store.get("price_range");
		let pac_range = store.get("pac_range");
		let { price_min, price_max } = price_range? price_range: {price_min: 0, price_max: 200000};
		let { pac_min, pac_max } = pac_range? pac_range: {pac_min: 0, pac_max: 0};
		params["price_min"] = price_min;
		params["price_max"] = price_max;
		params["pac_min"] = pac_min;
		params["pac_max"] = pac_max;
		this.setState({params});
		this.handleLoadData(1, params);
	}*/

  handleLoadProgram() {
    $.get(API_PROGRAM).then((result) => {
      this.setState({
        optionPrograms: result.payload.map((opt) => ({
          value: opt.id,
          label: opt.name,
        })),
      });
    });
  }
  handleLoadEntityType() {
    $.get(API_ENTITY_TYPE).then((result) => {
      this.setState({
        optionEntityTypes: result.payload.map((opt, index) => ({
          value: opt.id || index + 1,
          label: opt.name,
        })),
      });
    });
  }

  handleResultData = (result) => {
    let list = this.state.list;
    let params = this.state.params;
    
    // Validate response format
    if (!result || !result.payload) {
      console.error("Invalid API response format:", result);
      this.toggleLoading();
      this.setState({ end: true });
      notify.show("Format data tidak valid. Silakan coba lagi.", "error");
      return;
    }

    if (!Array.isArray(result.payload)) {
      console.error("API response payload is not an array:", result.payload);
      this.toggleLoading();
      this.setState({ end: true });
      notify.show("Format data tidak valid. Silakan coba lagi.", "error");
      return;
    }

    if (!params["offset"]) {
      list = result.payload;
    } else {
      list.push(...result.payload);
    }

    let end =
      result.payload.length === 0 ||
      result.payload.length < CourseCatalog.LIMIT;
    this.setState({
      end: end,
      list: list,
      offset: params["offset"] + CourseCatalog.LIMIT,
    });
    this.toggleLoading();

    if (this.state.user && !this.state.user.completed_profile) {
      $("#trigger-modal-completed-profile").trigger("click");
    }
  };

  handleLoadData = (reset, params) => {
    if (!params) {
      params = this.state.params;
    }

    params["limit"] = CourseCatalog.LIMIT;
    let isEnd = this.state.end;

    if (reset) {
      params["offset"] = 0;
      this.setState({ list: [], offset: params["offset"], end: false });
      isEnd = false;
    } else {
      params["offset"] = this.state.offset;
    }

    if (!isEnd) {
      this.toggleLoading(1);
      console.log("Loading courses with params:", params);
      console.log("API endpoint:", API_SEARCH);
      $.get(API_SEARCH, params)
        .then((result) => {
          // console.log("API response received:", result);
          this.handleResultData(result);
        })
        .catch((error) => {
          // console.error("Error loading courses:", error);
          // console.error("Error status:", error.status);
          // console.error("Error response:", error.responseJSON);
          this.toggleLoading();
          this.setState({ end: true });
          if (error.responseJSON && error.responseJSON.message) {
            notify.show(error.responseJSON.message, "error");
          } else if (error.status === 0) {
            notify.show("Tidak bisa terhubung ke server. Silakan cek koneksi Anda.", "error");
          } else {
            notify.show("Gagal memuat data kursus. Silakan coba lagi.", "error");
          }
        });
    }
  };

  activateFilter = () => {
    const { price_min, price_max } = store.get("price_range");
    const { pac_min, pac_max } = store.get("pac_range");
    const course_category = store.get("course_category");
    if (price_max < price_min) {
      notify.show(
        "Harga maksimal harus lebih besar dari harga minimal",
        "warning"
      );
    } else if (pac_max < pac_min) {
      notify.show("PAC maksimal harus lebih besar dari PAC minimal", "warning");
    } else {
      let { params } = this.state;
      params["price_min"] = price_min;
      params["price_max"] = price_max;
      params["pac_min"] = pac_min;
      params["pac_max"] = pac_max;
      params["category_id"] = course_category;
      this.setState({ params });
      this.handleLoadData(1);
      $("#scrolling-modal-close").click();
    }
  };

  toggleLoading(on) {
    if (on) {
      $(".load-more").show();
    } else {
      $(".load-more").hide();
    }
  }

  // handleFilterType = (e) => {
  // 	let params = this.state.params;
  // 	params["type"] = e.target.value;
  // 	this.setState({params : params});
  // 	this.handleLoadData(1);
  // }

  _loadMoreContent = () => {
    if (!this.state.end && this.state.list.length > 0) {
      this.handleLoadData();
    }
  };

  /*onResetClick = () => {
		$(".reset-range").click();
		this.handleLoadData(1, {category_id: 0});
	}*/

  render() {
    const { optionPrograms, optionEntityTypes, list, params } = this.state;
    let title = params.category_id ? trans.training : trans.course;

    // const activate_button = (
    //   <Button
    //     className="btn-pa full-width-buttons"
    //     onClick={this.activateFilter}
    //   >
    //     {trans.apply}
    //   </Button>
    // );

    return (
      <div>
        <Beforeunload
          onBeforeunload={() => {
            store.remove("price_range");
            store.remove("pac_range");
          }}
        />
        <div className="bg-white row mb-0 border-bottom shadowed floating-bottom-bar">
          <Row>
            <Col
              s={12}
              className="valign-wrapper pad-m buttons-div"
              id="filter-button-div"
            >
              <img className="font-orange-red" src={filter} />
              <span>Filter</span>
            </Col>
            {/* <Col l={6} m={6} s={6} className="valign-wrapper pad-m buttons-div">
              <img className="font-orange-red" src={sort} />
              <span>Sortir</span>
            </Col> */}
          </Row>
          <Modal
            trigger={
              <span id="filter-modal-button" className="hide">
                Filter
              </span>
            }
            id="filter-modal"
            bottomSheet={true}
          >
            <div id="scrolling-modal-close" className="modal-close">
              <i className="fa fa-close" />
            </div>
            <br />
            {/* <NewCourseCatalog /> */}
            <FilterCategory
              params={params}
              optionPrograms={optionPrograms}
              optionEntityTypes={optionEntityTypes}
              onChange={this.handleChangeFilter}
            />
            {/* {activate_button} */}
          </Modal>
        </div>
        <div>
          {/* <Col m={4} l={3} id="desktop-filter">
						<div className="left">
							<h5 className="valign-wrapper font-heavy">
								<Icon className="mr-xs" small>
									tune
								</Icon>
								{trans.filter}
							</h5>
						</div>
						<div className="right" onClick={() => $(".reset-range").click()}>
							<span id="reset-filter-desktop">Reset</span>
						</div>
					<NewCourseCatalog /> */}
          {/* activate_button */}
          {/*	  			<div className="strong mb-s">{trans.type}</div>
  				<Input onChange={this.handleFilterType} name='type' value="" type='radio' label={trans.all + " " + trans.course} className='with-gap' checked={!this.state.params.type} />
				<br/ ><br/ >
				<Input onChange={this.handleFilterType} name='type' value="1" type='radio' label={trans.free_course} className='with-gap' checked={this.state.params.type === 1} />
				<br/ ><br/ >
				<Input onChange={this.handleFilterType} name='type' value="2" type='radio' label={trans.paid_course} className='with-gap' checked={this.state.params.type === 2} />*/}
          {/* </Col> */}
          <div className="mb-xl">
            <div
              className="text-center"
              style={{
                background: "#D8EDF8",
                padding: "60px",
                color: "#3EA6DA",
              }}
            >
              {params.query && (
                <h5 className="mb-m">
                  <span>
                    {trans.search_result} {trans.for} :{" "}
                  </span>
                  {params.query}
                </h5>
              )}
              {!params.query && (
                <h5
                  className="font-heavy catalog-title"
                  style={{ fontSize: "36px" }}
                >
                  {title}
                </h5>
              )}
            </div>

            <div className="container mt-m">
              <div className="container-catalog">
                <div
                  className="catalog-left"
                  style={{
                    flexShrink: 0,
                  }}
                >
                  {optionPrograms.length > 0 && optionEntityTypes.length > 0 ? (
                    <div className="filter-category">
                      <FilterCategory
                        params={params}
                        optionPrograms={optionPrograms}
                        optionEntityTypes={optionEntityTypes}
                        onChange={this.handleChangeFilter}
                      />
                    </div>
                  ) : null}
                </div>
                <div className="catalog-right">
                  {list.length === 0 && this.state.end && (
                    <span>{title + " " + trans.not_found}</span>
                  )}

                  <div className="product-container">
                    {list.length > 0 &&
                      list.map((item, i) => (
                        <CourseItem data={item} key={"course-item-" + i} />
                      ))}
                  </div>

                  <Waypoint onEnter={this._loadMoreContent} />

                  {!this.state.end && (
                    <div className="center load-more mt-m">
                      <Preloader size="medium" />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

var timeout = null;
class FilterCategory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      entityTypeId: this.props.params.entity_type_id
        ? this.props.params.entity_type_id.split(",")
        : [],
      programId: this.props.params.program_id
        ? this.props.params.program_id.split(",")
        : [],
      accessType: this.props.params.access_type ? [this.props.params.access_type] : []
    };

    this.handleChangeValue = this.handleChangeValue.bind(this);
  }

  handleChangeValue(e) {
    let { entityTypeId, programId, accessType } = this.state;
    const { name, value } = e.target;

    if (name === "entityTypeId") {
      let index = entityTypeId.indexOf(value);
      if (index !== -1) {
        let listEntity = [...entityTypeId];
        listEntity.splice(index, 1);

        entityTypeId = listEntity;
      } else {
        entityTypeId = [...entityTypeId, value];
      }
    }

    if (name === "programId") {
      let index = programId.indexOf(value);
      if (index !== -1) {
        let listProgram = [...programId];
        listProgram.splice(index, 1);

        programId = listProgram;
      } else {
        programId = [...programId, value];
      }
    }

    if (name === "accessType") {
      accessType = accessType.indexOf(value) != -1 ? [''] : [value];
    }

    this.setState({ entityTypeId, programId, accessType });

    clearTimeout(timeout);
    timeout = setTimeout(() => {
      this.props.onChange({
        program_id: programId.join(","),
        entity_type_id: entityTypeId.join(","),
        access_type: accessType[0] || ''
      });
    }, 1000);

    // this.props.onChange({ programId, entityTypeId });
  }

  render() {
    const { optionPrograms, optionEntityTypes } = this.props;
    const { programId, entityTypeId, accessType } = this.state;

    return (
      <div>
        <div className="course-filter-title">Program</div>
        {optionPrograms &&
          optionPrograms.map((opt, i) => (
            <Row key={"program-" + i} className="course-filter">
              <Input
                name="programId"
                type="checkbox"
                value={opt.value.toString()}
                label={opt.label}
                checked={programId.includes(opt.value.toString())}
                onChange={this.handleChangeValue}
              />
            </Row>
          ))}
        <hr />
        <div className="course-filter-title">Tipe Entitas</div>
        {optionEntityTypes.map((opt, i) => (
          <Row key={"entity-" + i} className="course-filter">
            <Input
              name="entityTypeId"
              type="checkbox"
              value={opt.value.toString()}
              label={opt.label}
              checked={entityTypeId.includes(opt.value.toString())}
              onChange={this.handleChangeValue}
            />
          </Row>
        ))}

        <Modal
          id="modal-profile"
          header="Lengkapi Profil Anda"
          trigger={
            <Button
              waves="light"
              id="trigger-modal-completed-profile"
              style={{ display: "none" }}
            >
              Open
            </Button>
          }
        >
          Silakan lengkapi profil Anda untuk melanjutkan pembelajaran
          <div style={{ textAlign: "right", marginTop: "16px" }}>
            <Link to="/profile/edit" className="white-button">
              Lengkapi Profil
            </Link>
          </div>
        </Modal>
      </div>
    );
  }
}

export default CourseCatalog;



// WEBPACK FOOTER //
// ./src/components/Course/Catalog.js